<template>
  <nav class="gnb">
    <ul class="lst_gnb">
      <li class="gnb_menu is_pc_ibshow" v-if="isGnbMenuShow(gnbMenu)" :class="{is_point: gnbMenu.type == 'button'}" v-for="gnbMenu in gnbMenus" :key="gnbMenu.content"
        @mouseover="hoverCustomMenu(gnbMenu, true)" @mouseout="hoverCustomMenu(gnbMenu, false)">
        <router-link-ex :condition="!gnbMenu.isExternal" :to="addCountryIfHomepageUrl(gnbMenu.url)" class="link_menu" :class="{ 'is_hover': gnbMenu.hover }"
          active-class="is_selected" :target="gnbMenu.isBlank ? '_blank' : '_self'">
          <span class="menu_txt">{{ isEmpty(gnbMenu.messageId) ? gnbMenu.content : $t(gnbMenu.messageId) }}</span>
        </router-link-ex>
        <div class="drop_menu_wrap" :class="addSubMenuClass(gnbMenu)" v-if="isGnbSubMenuShow(gnbMenu)" @mouseover="hoverCustomMenu(gnbMenu, true)"
             @mouseout="hoverCustomMenu(gnbMenu, false)">
          <ul class="lst_gnb_sub" v-if="exist(gnbMenu.subMenus)">
            <li class="gnb_sub_menu" v-for="subMenu in gnbMenu.subMenus" :key="subMenu.content" v-if="isGnbSubMenuPartShow(subMenu)">
              <router-link-ex :to="addCountryIfHomepageUrl(subMenu.url)"
                              class="menu_txt" :class="subMenu.addClass"
                              @click.native="hoverCustomMenu(gnbMenu, false)"
                              :condition="!subMenu.isExternal" :target="subMenu.isBlank ? '_blank' : '_self'">
                {{ isEmpty(subMenu.messageId) ? subMenu.content : $t(subMenu.messageId) }}
              </router-link-ex>
            </li>
          </ul>
          <component :is="gnbMenu.subMenuComponent" v-if="exist(gnbMenu.subMenuComponent)" @close="hoverCustomMenu(gnbMenu, false)" />
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { isEmpty } from 'lodash-es'

import GnbHeaderMenuCommon from './GnbHeaderMenuCommon'

export default {
  mixins: [GnbHeaderMenuCommon],
  methods: {
    isEmpty: isEmpty
  }
}
</script>
